var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutstandingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 33.75,
    fill: "#B00020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8203 59.1797C34.8047 63.0859 39.5312 65.0391 45 65.0391C50.4688 65.0391 55.1562 63.0859 59.0625 59.1797C63.0469 55.1953 65.0391 50.4688 65.0391 45C65.0391 39.5312 63.0469 34.8438 59.0625 30.9375C55.1562 26.9531 50.4688 24.9609 45 24.9609C39.5312 24.9609 34.8047 26.9531 30.8203 30.9375C26.9141 34.8438 24.9609 39.5312 24.9609 45C24.9609 50.4688 26.9141 55.1953 30.8203 59.1797ZM27.3047 27.4219C32.2266 22.5 38.125 20.0391 45 20.0391C51.875 20.0391 57.7344 22.5 62.5781 27.4219C67.5 32.2656 69.9609 38.125 69.9609 45C69.9609 51.875 67.5 57.7734 62.5781 62.6953C57.7344 67.5391 51.875 69.9609 45 69.9609C38.125 69.9609 32.2266 67.5391 27.3047 62.6953C22.4609 57.7734 20.0391 51.875 20.0391 45C20.0391 38.125 22.4609 32.2656 27.3047 27.4219ZM42.5391 32.4609H47.4609V47.4609H42.5391V32.4609ZM42.5391 52.5H47.4609V57.5391H42.5391V52.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutstandingIcon);
export default __webpack_public_path__ + "static/media/outstanding-icon.1bfd004435a1055b20319209a998aa7c.svg";
export { ForwardRef as ReactComponent };